export default __webpack_public_path__ + "static/media/leftgroup.bb42b75b.svg";